
















































import Vue from 'vue';

export default Vue.extend({
  name: 'CustomDialog',
  props: {
    value: {
      type: Boolean,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    noGutter: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    value() {
      this.dialog = this.value;
    },
  },
});
